import { useEffect, useRef } from 'react';
// @ts-ignore
import { storage } from '@gp/utils/utils';
import { STRATEGIC_STORAGE_KEY } from '@sg/constants/storageKeys';

/**
 * Hook to handle auto-scroll to Notes section when returning from document preview
 */
export const useNotesAutoScroll = (
  notesRef?: React.RefObject<HTMLDivElement>,
  loading?: boolean
) => {
  const hasScrolled = useRef(false);

  // Auto-scroll to Notes when returning from document preview
  useEffect(() => {
    if (hasScrolled.current || loading || !notesRef) {
      return;
    }

    const shouldScroll = storage.getSessionStorageItem(
      STRATEGIC_STORAGE_KEY.STUDIOS_NOTES_ID
    );

    if (shouldScroll) {
      setTimeout(() => {
        if (notesRef.current) {
          notesRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
          hasScrolled.current = true;
        }
        storage.removeSessionStorageItem(STRATEGIC_STORAGE_KEY.STUDIOS_NOTES_ID);
      }, 1000);
    }
  }, [notesRef, loading]);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      storage.removeSessionStorageItem(STRATEGIC_STORAGE_KEY.STUDIOS_NOTES_ID);
    };
  }, []);

  // Reset scroll flag when switching studios
  const resetScrollFlag = () => {
    hasScrolled.current = false;
  };

  return { resetScrollFlag };
};
